module.exports = "//static.hsappstatic.net/UserPreferencesUI/static-1.24413/images/email.svg"